import { createFileRoute } from "@tanstack/react-router";
import { AdminAccessProvider } from "@/hooks/useAdminAccess";
import { PortalErrorBoundary } from "@/components/PortalErrorBoundary";

// Pathless admin layout: a page crash renders an inline fallback that resets
// on navigation instead of blanking the whole app.
export const Route = createFileRoute("/_admin")({
  component: AdminLayoutRoute,
});

function AdminLayoutRoute() {
  return (
    <AdminAccessProvider>
      <PortalErrorBoundary />
    </AdminAccessProvider>
  );
}
